<template>
  <div
    class="install"
    @click.prevent.stop="onInstall"
  >
    <img
      class="install_picto"
      src="favicon-32x32.png"
    >
    <p class="install_label color-blue-500">Installer l'application Yaniv Scores ?</p>
    <div
      class="install_close"
      @click.prevent.stop="onClose"
    >&#10005;</div>
  </div>
</template>

<script>
export default {
  name: 'install',
  methods: {
    onInstall() { this.$emit('install') },
    onClose() { this.$emit('close') },
  },
}
</script>

<style lang="stylus">
.install
  position fixed
  bottom 0
  left 0
  display flex
  align-items center
  background white
  width 100%
  padding 10px
  box-sizing border-box
  cursor pointer
  &_picto
    width 30px
    height @width
    border-radius @width
    margin-right 10px
  &_label
    margin-right 10px
  &_close
    margin-left auto
    background transparent
    display block
    width 25px
    height @width
    border-radius @width
    line-height @width
    text-align center
    font-size round(@width * 0.65)
    &:hover
      background lightgrey
</style>



// WEBPACK FOOTER //
// Install.vue?fba783cc